import { useSelector } from 'react-redux';
import { selectUnsavedFormData } from 'pages/commonSelectors';
import {
  selectSingleItemData,
  selectSelectedColumnsData,
  selectFilterData,
  selectFilterCriteriaData,
  selectSelectedRowsData,
  selectCreationFormData
} from 'pages/LooseItems/LooseItemsList/selectors';

export function useLooseItemSelector() {
  // Summary
  const customColumns = useSelector(selectSelectedColumnsData());

  const filter = useSelector(selectFilterData());
  const filterCriteria = useSelector(selectFilterCriteriaData());

  const selectedRows = useSelector(selectSelectedRowsData());

  // Others
  const unsavedFormData = useSelector(selectUnsavedFormData());

  const currentLooseItem = useSelector(selectSingleItemData());

  const creationForm = useSelector(selectCreationFormData());

  return {
    filter,
    filterCriteria,
    selectedRows,
    customColumns,
    unsavedFormData,
    currentLooseItem,
    creationForm
  };
}
